
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;


    class Arcticicemin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/data/explore/cli005d-Historical-Minimum-Arctic-Sea-Ice?section=Discover&zoom=3&lat=0&lng=0&pitch=0&bearing=0&basemap=dark&labels=light&layers=%255B%257B%2522dataset%2522%253A%2522a99c5cf5-f141-4bed-a36d-b04c8e171dfa%2522%252C%2522opacity%2522%253A1%252C%2522layer%2522%253A%25228b4453fd-183a-4e4a-ba7e-ee1a1c6e6de3%2522%257D%255D&page=1&sort=most-viewed&sortDirection=-1'
        };
    }

    render() {
        return (
             <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Arcticicemin;